import React, { useReducer, useEffect } from "react";
import axios from "axios";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import { initialize, checkCurrentStatus, signIn, fetchUser } from "../../oauth";
import { LOGIN, LOGOUT, UPDATE_CREDENTIAL, SIGNIN } from "../../data/constants";

const AuthStore = (props) => {
  // const localState = window.localStorage.getItem("jsi-portal-state");
  const initialState = {
    user: null,
    error: null,
    token: null,
    credential: null,
  };
  //const [state, dispatch] = useReducer(AuthReducer, localState || initialState);

  const [state, dispatch] = useReducer(AuthReducer, initialState);
  useEffect(() => {
    const localState = JSON.stringify(state);
    // try {
    //   window.localStorage.setItem("jsi-portal-state", localState);
    // } catch (err) {
    //   console.log("Error in storing local state");
    // }
    // console.log("LOGIN state", localState, localState.user);
  }, [state]);

  // const login = async () => {
  //   const config = {
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     },
  //   };
  //   const bodyFormData = new URLSearchParams();
  //   bodyFormData.append("username", TokenRequest.userName);
  //   bodyFormData.append("password", TokenRequest.password);
  //   bodyFormData.append("client", TokenRequest.client);
  //   bodyFormData.append("ip", TokenRequest.ipAdress);
  //   bodyFormData.append("expiration", TokenRequest.expiration);
  //   bodyFormData.append("f", TokenRequest.format);
  //   bodyFormData.append("referer", "http://localhost:3000");

  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       console.log("calling AUTH token");
  //       const resp = await axios.post(
  //         TokenRequest.tokenURL,
  //         bodyFormData,
  //         config
  //       );
  //       console.log("AUTH token", resp.data);
  //       dispatch({
  //         type: LOGIN,
  //         payload: resp.data,
  //       });
  //       resolve(resp.data);
  //     } catch (err) {
  //       // console.log("Error", err);
  //       reject("Error");
  //     }
  //   });
  // };

  const loadApp = async () => {
    const oauthInfo = initialize(
      process.env.REACT_APP_ID,
      process.env.REACT_APP_PORTAL_URL
    );
    let credential = await checkCurrentStatus(oauthInfo);

    return new Promise(async (resolve, reject) => {
      try {
        if (!credential) {
          // signin
          credential = await signIn(oauthInfo);
          console.log("$$sign in", credential);
        }

        if (credential) {
          const user = await fetchUser();
          console.log("$$User", user);
          dispatch({
            type: SIGNIN,
            payload: {
              userName: user?.fullName,
              role: user?.role,
              userID: user?.username,
            },
          });
          resolve(true);
          // btnAuth.innerText = `Log Out ${user.username}`;
        }
      } catch (err) {
        // console.log("Error", err);
        reject(false);
      }
    });
  };

  const logout = () => {
    //TO-DO
    dispatch({
      type: LOGOUT,
    });
  };

  const updateCredential = (credential) => {
    //TO-DO
    dispatch({
      type: UPDATE_CREDENTIAL,
      payload: credential,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        logout,
        updateCredential,
        loadApp,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthStore;
